import {NavLink} from 'react-router-dom';
import {Button, Typography} from 'antd';
import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {AppRoutePaths} from '../../../routing/Routes';
import {CustomerDto} from '../../../../../../PRMGApiClient';

export const customerListColumn: ColumnsType<CustomerDto> = [
  {
    title: t('Last Name'),
    dataIndex: 'lastName',
    key: 'lastName',
    filters: [{text: 'Company', value: true}],
    sorter: true,
    render: (text, record) => (
      <Button type="link" className="p-0">
        <NavLink to={`${AppRoutePaths.customers.url}/${record.customerId}`}>
          {text}, {record.firstName}
        </NavLink>
      </Button>
    ),
  },
  {
    title: t('E-mail'),
    dataIndex: 'email',
    key: 'email',
    sorter: true,
  },
  {
    title: t('Phone'),
    dataIndex: 'phone',
    key: 'phone',
    sorter: true,
  },
  {
    title: t('Client Type'),
    dataIndex: 'isCompany',
    key: 'isCompany',
    sorter: true,
    render: (text) => <Typography.Text>{text === true ? 'company' : 'individual'}</Typography.Text>,
  },
  {
    title: t('Company Name'),
    dataIndex: 'companyName',
    key: 'companyName',
    sorter: true,
    render: (text) => <Typography.Text strong>{text}</Typography.Text>,
  },
  {
    title: t('NIP'),
    dataIndex: 'nip',
    key: 'nip',
    sorter: true,
    render: (text) => <Typography.Text strong>{text}</Typography.Text>,
  },
];
